import { request } from '@/shared/api/request'

export const getTradeUnion = async (isEmployee = false) => {
	return request({ url: `colcontract/tradeUnion/get/current?isEmployee=${isEmployee}` })
}
